/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ERegistrationFormType } from "../types/ERegistrationFormType.ts";

/**
 * @description 1 = Complete | 2 = Compact | 3 = CompactWithVerification | 4 = Simple | 5 = Latest | 6 = LatestFMVZ | 7 = LatestPecegeCollege | 8 = LatestPoli | 9 = LatestCiaam | 10 = LatestPecegeCollegeMBA | 11 = LatestMiniCourse |
 */
export const eRegistrationFormTypeSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
    z.literal(10),
    z.literal(11),
  ])
  .describe(
    "1 = Complete | 2 = Compact | 3 = CompactWithVerification | 4 = Simple | 5 = Latest | 6 = LatestFMVZ | 7 = LatestPecegeCollege | 8 = LatestPoli | 9 = LatestCiaam | 10 = LatestPecegeCollegeMBA | 11 = LatestMiniCourse | ",
  ) as unknown as ToZod<ERegistrationFormType>;
